import { gql } from "@apollo/client";

export const GET_INSTITUCIONES_PAGINADAS = gql`
query GetAllInstitucionesByDelegacion (
    $skip: Int
    $take: Int
    $where: t_institucionNoSAPFilterInput
    $order: [t_institucionNoSAPSortInput!]
) {
    allInstitucionesByDelegacion (skip: $skip, take: $take, where: $where, order: $order)
        {
            items {
                cod_Institucion,
                nombre,
                domicilio
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
}`;